import { FC } from 'react';

import Image from './image.svg';

export const LogoSmall: FC = () => <img src={Image} alt="small logo" />;
